import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<any[], any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useUserList = (): UseQueryResult<
    AxiosResponse<any[], any>,
    unknown
> => {
    const { getToken } = useAuth();

    return useQuery('userWallets', async () =>
        getQueryData('/metadata/user/wallet', getToken())
    );
};
